<template>
  <div class="animated fadeIn list-of-so">
    <b-card>
      <div slot="header">
        PENJUALAN
        <div class="card-header-actions">
          <b-form-radio-group  v-model="tblData.viewOption">
              <b-form-radio value="Lines">View Line/Items</b-form-radio>
              <b-form-radio value="Header">View Header</b-form-radio>
              <b-form-radio value="Binder">Binder/Gabungan</b-form-radio>
          </b-form-radio-group>                  
          <b-button variant="btn btn-primary mr-1" @click="add" v-if="(tblData.viewOption!='Binder')">Add</b-button>
          <b-button variant="primary mr-1" @click="edit" v-if="(tblData.viewOption!='Binder')">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="addBinder" v-if="(tblData.viewOption=='Binder')">Add Binder</b-button>
          <b-button variant="primary mr-1" @click="editBinder" v-if="(tblData.viewOption=='Binder')">Edit Binder</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>

          <!-- <b-button variant="primary mr-1" @click="posting()" v-if="(tblData.viewOption!='Binder')">Generate Invoice</b-button> -->
          <b-button variant="primary mr-1" @click="posting()" v-if="(tblData.viewOption!='Binder')"><i :class="editonly?'fa fa-pencil':''"></i> <span v-if="editonly"> Edit Invoice</span><span v-else> Generate Invoice</span></b-button>
          
          <b-button variant="primary mr-1" @click="printInv()" v-if="(tblData.viewOption!='Binder')">Print Invoice</b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Tgl. Penjualan</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>No. Penjualan</label></b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" placeholder="sales order number"></b-form-input>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Order Type</span></b-input-group-prepend>
            <b-form-select v-model="tblData.orderType" :plain="true" :options="orderTypes"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input v-model="tblData.CustName" @change="tbldata.customer_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn variant="primary" @click="lkuCustShow=true"> <i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="pt-2 pl-2">Sales</span></b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" @change="tbldata.salesae_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Item</label></b-input-group-prepend>
            <b-form-input v-model="tblData.itemname" @change="tblData.itemno=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuItemShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label >Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
              <b-button class="btn btn-success ml-4 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment('DD-MMM-YYYY')}}</template>
        <template v-slot:cell(invdate)="data"><span v-if="(data.item.invdate)">{{ data.item.invdate | moment('DD-MMM-YYYY')}}</span></template>
        <template v-slot:cell(ttlgross)="data">{{ data.item.ttlgross | numFormat }}</template>
        <template v-slot:cell(ttldiskon)="data">{{ data.item.ttldiskon | numFormat }}</template>
        <template v-slot:cell(ttlnetto)="data">{{ data.item.ttlnetto | numFormat }}</template>
        <template v-slot:cell(qty)="data">{{ data.item.qty | numFormat }}</template>
        <template v-slot:cell(unitprice)="data">{{ data.item.unitprice | numFormat }}</template>
        <template v-slot:cell(hargajual)="data">{{ data.item.hargajual | numFormat }}</template>
        <template v-slot:cell(nilai)="data">{{ data.item.nilai | numFormat }}</template>
        <template v-slot:cell(nilaidisc)="data">{{ data.item.nilaidisc | numFormat }}</template>
        <template v-slot:cell(nilainett)="data">{{ data.item.nilainett | numFormat }}</template>
        <template v-slot:cell(Total)="data">{{ data.item.Total | numFormat }}</template>
        <template v-slot:cell(TotalRekap)="data">{{ data.item.TotalRekap | numFormat }}</template>

        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
          <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            v-if="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>


      <b-modal v-model="showBinderFrm" header-bg-variant="primary"  title="Binder Laporan Gabungan(Group)" size="lg" :centered="true" @ok="saveBinder" ok-title="Save">
              <b-row>
                  <b-col lg="6" xl="5">                            
                  <b-input-group>
                      <b-input-group-append><span class="input-group-text">Tgl. Laporan</span></b-input-group-append>
                      <b-form-input v-model="BinderFrm.tanggal" :state="!$v.BinderFrm.tanggal.$error"></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-row >    
            <b-input-group>
                <b-input-group-prepend><label>Customer / Induk</label></b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" :state="!$v.BinderFrm.customer_id.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" @click="lkuCustShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Keterangan</label></b-input-group-prepend>
                <b-form-input v-model="BinderFrm.uraian" readonly></b-form-input>
            </b-input-group>
            <b-form-row>
              <b-col lg="8">
                <b-input-group>
                  <b-input-group-prepend><label>Total Penjualan</label></b-input-group-prepend>
                  <b-input-group-prepend><span class="input-group-text">{{uanguser}} </span></b-input-group-prepend>                
                  <my-number class="form-control text-right" v-model="BinderFrm.Total" :precision="2" :state="!$v.BinderFrm.Total.$error"></my-number>
                </b-input-group>                
              </b-col>
            </b-form-row>
      </b-modal>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="lkuCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-cust @click="onSelectCust"></lku-cust>
    </b-modal>
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="Daftar Item"  :centered="true">
            <lku-item @click="onSelectLkuItem" :lkuData="lkuItemData"></lku-item>
        </b-modal>        

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
 }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
toastr.init();

import myNumber from "../../components/my-number";
// LKU
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";

import penjualan from "../../apis/bakerysales";
import arinv from "../../apis/arinv";

export default {
  components: { Loading, myNumber, lkuItem, lkuCust, lkuSalesae},
  mixins: [validationMixin],
  validations: {
        BinderFrm: {
            tanggal: { required },
            customer_id: { required },
            Total: { required },
        },
  },
  data() {
    return {
      showBinderFrm: false,
      BinderFrm: {tanggal: moment().format('YYYY-MM-DD'),
                  customer_id:'', Total:0
                  },
      uanguser: this.$store.state.user.matauang,
      showDelConfirm: false,
      lkuItemShow:false,
      lkuItemData:{},
      lkuCustShow: false,
      lkuSalesShow: false,
      editonly:false,
      byae: false,
      showFilter: false,
      showReport: false,
      reportUrl: null,
      items:[],
      limit: 15,
      pagination:true,
      tblData: {
        viewOption:'Header',
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().format('YYYY-MM-DD'),
        sortBy: 'tanggal',
        sortDesc: true,
      },
      tblFields: [
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "nomor",
            thStyle: "width:80px",
            label: "No. Penjualan",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Tgl. Penjualan",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            sortable: true
          },
          {
            key: "SalesExName",
            label: "Sales/Marketing",
            sortable: true
          },
          {
            key: "nomorDeliv",
            thStyle: "width:120px",
            label: "No. DO",
            sortable: true
          },
          {
            key: "ttlgross",
            label: "Gross",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ttldiskon",
            label: "Discount",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ttlnetto",
            label: "Netto",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
        ],      
      customerGroups:[{value:'', text:'--ALL--'},{value:'RETAIL', text:'RETAIL'}, {value:'WHOLESHALE', text:'WHOLESHALE'}],
      orderTypes:['Non Konsinyasi','Konsinyasi']
    };
  },
  computed: {
    invalidModel() {
      this.$v.BinderFrm.$touch();
      return this.$v.BinderFrm.$invalid;
    },
  }, 
  watch: {
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.viewOption" : function(newval) {
      if (newval=='Header') {
        this.tblFields=[
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "nomor",
            thStyle: "width:80px",
            label: "No. Penjualan",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Tgl. Penjualan",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            sortable: true
          },
          {
            key: "SalesExName",
            label: "Sales/Marketing",
            sortable: true
          },
          {
            key: "nomorDeliv",
            thStyle: "width:120px",
            label: "No. DO",
            sortable: true
          },
          {
            key: "ttlgross",
            label: "Gross",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ttldiskon",
            label: "Discount",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ttlnetto",
            label: "Netto",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
        ];
      } else if (newval=='Lines') {
        this.tblFields= [
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "nomor",
            thStyle: "width:80px",
            label: "No. Penjualan",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Tgl. Penjualan",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            sortable: true
          },
          {
            key: "nomorDeliv",
            thStyle: "width:120px",
            label: "No. DO",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "hargajual",
            label: "Price",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "qty",
            thStyle: "width:40px",
            label: "Qty. Jual",
            sortable: true
          },
          {
            key: "nilai",
            label: "Gross",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaidisc",
            label: "Discount",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilainett",
            label: "Netto",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },

        ];
      } else {
        this.tblFields=[
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "CustName",
            label: "Customer",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Tgl. Laporan",
            sortable: true
          },
          {
            key: "uraian",
            label: "Keterangan",
            sortable: true
          },
          {
            key: "Total",
            label: "Total Penjualan",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "SalesExName",
            label: "Sales/Marketing",
            sortable: true
          },          
          {
            key: "TotalRekap",
            label: "Rekap Input Laporan",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "invoiceno",
            thStyle: "width:80px",
            label: "Invoice Number",
            sortable: true
          },
          {
            key: "invdate",
            thStyle: "width:90px",
            label: "Inv. Date",
            sortable: true
          },
          {
            key: "createby",
            tdClass: "text-center",
            label: "Input oleh",
            thStyle: "width:100px",
            sortable: true
          },
        ];

      }
      this.tblData.sortBy='tanggal';
      this.refresh();
    },
  },
  created: async function() {
    if (this.$route.params.byae==1)  {
      this.tblData.createby=this.$store.state.user.username;
      this.byae=true;
    }
  },
  methods: {
      
    onSelectCust(_selected) {
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.lkuCustShow = false;
    },
    onSelectsales(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },
    onSelectLkuItem(lkuData) {
        this.lkuItemData=lkuData;
        this.lkuItemShow=false;

        this.tblData.itemname = lkuData.selected.itemname
        this.tblData.itemno =  lkuData.selected.itemno;
    },    
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.SalesorderList) {
            this.tblData[key] = filter.SalesorderList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.SalesorderList.tgl1 || '';
          this.tblData.tgl2=filter.SalesorderList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.SalesorderList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  let list ;
                  if (this.tblData.viewOption=='Header') {
                    list = await penjualan.list(this.tblData);
                  } else if (this.tblData.viewOption=='Lines') {
                    list = await penjualan.listline(this.tblData);
                  } else {
                    list = await penjualan.listbinder(this.tblData);
                  }
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }

        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  let list ;
                  if (this.tblData.viewOption=='Header') {
                    list = await penjualan.list(this.tblData);
                  } else if (this.tblData.viewOption=='Lines') {
                    list = await penjualan.listline(this.tblData);
                  }
                   else {
                    list = await penjualan.listbinder(this.tblData);
                  }
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.customer_id = "";
      this.tblData.Advertiser = "";
      this.tblData.campaign = "";
      this.tblData.campaignKey = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.ExtrDocNo = "";
      this.tblData.sales_search = "";
      // this.refresh();
    },
    rowClicked(record, index) {
      console.log('record',record);
      if(record.arinvKey){
        this.editonly = true;
      }else{
        this.editonly = false;
      }
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['Advertiser', 'brand', 'campaign', 'campaignKey', 'customer', 'customer_id', 'DimCol', 'DimColInfo', 'DimVal', 'ExtrDocNo', 'iscompliment', 'isdiscount', 'issavingrate', 'nomor', 'sales_search', 'tahun', 'tgl1', 'tgl2', 'status', 'uraian', 'createby'];
      let filtered = false;
      const SalesorderList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              SalesorderList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          SalesorderList.page=this.tblData.page;
          SalesorderList.limit=this.tblData.limit;
          SalesorderList.sortBy=this.tblData.sortBy;
          SalesorderList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.SalesorderList=SalesorderList;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.printsales();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add: function() {
      this.saveFilter();
      router.push({ name: "bakery.penjualanfrm" });
    },
    edit: function() {
      if (!this.model) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
        this.saveFilter();
        router.push({
          name: "bakery.penjualanfrm",
          params: { SaleHdrId: this.model.SaleHdrId }
        });
      }
    },
    deleteConfirm(item) {
      // this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        this.model.option = this.tblData.viewOption;
        await penjualan.remove(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
          this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    addBinder: function() {
      this.BinderFrm= {tanggal: moment().format('YYYY-MM-DD'),
                  customer_id:'', Total:0
                  };
      this.showBinderFrm=true;
    },
    editBinder: function() {
      if (!this.model) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
          this.BinderFrm= {tanggal: moment().format('YYYY-MM-DD'),
                  customer_id:'', Total:0
                  };
            for (var key in this.model) {
                this.BinderFrm[key] = this.model[key];
            }
          this.showBinderFrm=true;
      }
    },
    saveBinder: async function() {
      if (this.invalidModel) {
            const invalidobj={};
            for (var key in this.$v.BinderFrm) {
              if (this.$v.BinderFrm[key].$anyError) {
                if (this.$v.BinderFrm[key].$anyError==true) invalidobj[key] = this.$v.BinderFrm[key];
              }
            }        
            console.log('validation model: ', this.BinderFrm);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
            this.isLoading=true;
            await penjualan.savebinder(this.BinderFrm);
            this.refresh();
            this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }    
      }      
    },       
    posting() {
      if (!this.model) {
            toastr.warn('Please select a row that want to be GENERATE INVOICE!');
      } else {
        this.saveFilter();
        if((this.model.arinvKey || '')!==''){
            // toastr.info( `Invoice Telah di Generate ${this.model.invoiceno}.`);
            router.push({name :'bakery.arinvoicefrm', params: { arinvKey: this.model.arinvKey}});
        }else{
          router.push({
            name: "bakery.penjualanposting",
            params: { SaleHdrId: (this.model || {}).SaleHdrId || 'test'}
          });
        }
        
      }
    },
    async printsales(){
      if (!this.model) {
            toastr.warn('Please select a row that want to be Printed!');
      } else {
        this.showReport = true;
        this.reportUrl = await penjualan.print(this.model);
      }
    },    
    async printInv() {
      if (!this.model) {
          toastr.warn('Please select a row that want to be Printed!');
      }else if ((this.model.arinvKey||'')=='') {
          toastr.warn('Invoice belum digenerate');
      }
      else {
        
        this.showReport = true;
        this.reportUrl = await arinv.print(this.model);
      }
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        if (this.tblData.viewOption=='Binder') {
          const response = await penjualan.listbinderexport(this.tblData);
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'sales_list_binder.xlsx');
          document.body.appendChild(link);
          link.click();
        } else if (this.tblData.viewOption=='Header') {
          const response = await penjualan.export(this.tblData);
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'sales_list_header.xlsx');
          document.body.appendChild(link);
          link.click();
        } else {
          const response = await penjualan.listlineexport(this.tblData);
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'sales_list_detail.xlsx');
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({name: "bakery.home"});
    }
  }
};
</script>